<template>
  <div id="app">
    <div id="conteudo" :style="isMobile ? '' : 'padding-left: 60px;'">
      <conteudo></conteudo>
    </div>
    <div id="login" style="height: 100%; padding-top: 100px;">
      <div class="row">
        <div class="col-12" style="display: flex; justify-content: center;">
          <img style="width: 150px;" src="./assets/logo.png">
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="display: flex; justify-content: center;">
          <h1>Draco Min</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div style="margin-left: 30px; margin-right: 30px;" class="card border-primary ">
            <div class="container">
              <form>
                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label">Login </label>
                  <input type="email" v-model="vuser" class="form-control" id="exampleInputEmail1"
                    aria-describedby="emailHelp">

                </div>
                <div class="mb-3">
                  <label for="exampleInputPassword1" class="form-label">Senha</label>
                  <input type="password" v-model="vsenha" class="form-control" id="exampleInputPassword1">
                </div>

                <div class="col-12 mb-3">
                  <button style="width: 100%;" type="submit" @click.prevent="mtdlogin()"
                    class="btn btn-primary">Entrar</button>
                </div>
                <div class="col-12 mb-3">
                  <button style="width: 100%;" type="submit" @click.prevent="mtdcadastrar()"
                    class="btn btn-primary">Cadastrar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="cadastro" style="height: 100%; padding-top: 100px;">
      <div class="row">
        <div class="col-12" style="display: flex; justify-content: center;">
          <img style="width: 150px;" src="./assets/logo.png">
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="display: flex; justify-content: center;">
          <h1>Cadastro </h1>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div style="margin-left: 30px; margin-right: 30px;" class="card border-primary ">
            <div class="container">
              <form>
                <div class="row">


                  <div class="col-sm-12 col-lg-6 mb-3">
                    <label for="exampleInputEmail1" class="form-label">Nome</label>
                    <input type="email" v-model="vnome" class="form-control" id="exampleInputEmail1"
                      aria-describedby="emailHelp">
                  </div>
                  <div class="col-12 col-lg-6 mb-3">
                    <label for="exampleInputEmail2" class="form-label">CPF</label>
                    <input type="text" v-mask="'###.###.###-##'" v-model="vcpf" class="form-control"
                      id="exampleInputEmail2">

                  </div>
                  <div class="col-12 col-lg-6 mb-3">
                    <label for="exampleInputEmail3" class="form-label">Email (será usado no login)</label>
                    <input type="email" v-model="vuser" class="form-control" id="exampleInputEmail3"
                      aria-describedby="emailHelp">

                  </div>
                  <div class="col-12  col-lg-6 mb-3">
                    <label for="exampleInputPassword1" class="form-label">Crie uma senha</label>
                    <input type="password" v-model="vsenha" class="form-control" id="exampleInputPassword1">
                  </div>

                  <div class="col-12 mb-3">
                    <button style="width: 100%;" type="submit" @click.prevent="mtdconfirmacadastro()"
                      class="btn btn-primary">Confirma</button>
                  </div>
                  <div class="col-12 mb-3">
                    <button style="width: 100%;" type="submit" @click.prevent="mtdvoltar()"
                      class="btn btn-danger">Voltar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import util from './util'
import conteudo from './conteudo'

export default {
  name: 'App',
  components: {
    conteudo,

  },
  data: function () {
    return {
      vsenha: '',
      vuser: '',
      vnome: '',
      vcpf: '',
      isMobile: false,

      vusercadastro: '',
      vsenhacadastro: '',
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    definessessao(iduser, nome, foto) {
      localStorage.setItem('iduser', iduser);
      localStorage.setItem('nome', nome);
      localStorage.setItem('foto', foto);
      location.reload();
    },
    mtdcadastrar() {
      $('#login').hide();
      $('#cadastro').show();
    },
    mtdvoltar() {
      $('#cadastro').hide();
      $('#login').show();
    },
    mtdlogin() {
      var vself = this;

      let dadoslogin = {
        'usuario': this.vuser,
        'senha': this.vsenha
      }

      let parametros = [

        { parametro: 'op', valor: 'logar' },
        { parametro: 'dadoslogin', valor: JSON.stringify(dadoslogin) },

      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/rotinalogin.php');
      retorno.then(function (response) {
        if ($.isNumeric(response.data.inf)) {
          vself.definessessao(response.data.iduser, response.data.nome, response.data.foto);
        } else {
          alert(response.data.inf.substring(4));
        }
      }).catch(function (response) {

      });
    },
    mtdconfirmacadastro() {
      let vself = this;

      if (!this.vnome) {
        alert('Informe o seu nome');
        return
      }
      if (!this.vcpf) {
        alert('Informe o seu CPF');
        return
      }

      if (!this.vuser) {
        alert('Informe o seu E-Mail');
        return
      }
      if (!this.vsenha) {
        alert('Informe uma senha');
        return
      }

      let dadoscadastro = {
        'nome': this.vnome,
        'cpf': this.vcpf.replace(/\D/g, ''),
        'usuario': this.vuser,
        'senha': this.vsenha
      }

      let parametros = [

        { parametro: 'op', valor: 'cadastro' },
        { parametro: 'dadoscadastro', valor: JSON.stringify(dadoscadastro) },

      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/rotinalogin.php');
      retorno.then(function (response) {
        if ($.isNumeric(response.data)) {
          vself.definessessao(response.data, vself.vnome, '');
        } else {
          alert(response.data.substring(4));
        }
      }).catch(function (response) {

      });
    }
  },
  mounted() {


    this.isMobile = window.innerWidth <= 768;
    window.addEventListener('resize', this.checkMobile);



    const iduser = localStorage.getItem('iduser');
    $('#cadastro').hide();

    if (parseInt(iduser) > 0) {
      $('#login').hide();
      $('#conteudo').show();

    } else {
      $('#conteudo').hide();
      $('#login').show();
    }

    util.resetZoom();


  }
}
</script>

<style>
#conteudocrud {
  padding-bottom: 100px;
}

#conteudo {
  padding-top: 60px;
}

#btgravar {
  background-color: black !important;
}

.bdg-qtd-reg-info {
  color: cadetblue !important;
}

.select2-container--bootstrap .select2-selection {
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: transparent !important;
  border: 1px solid #ced4da;
  color: #495057;
  font-size: 1rem;
  outline: 0;
}
</style>
